<div class="container">
  <div class="accordion" id="accordionExample">
    <div class="card">
      <div class="card-header p-0" id="headingOne" style="font-size: 0.5em !important;">
        <h2 class="mb-0">
          <div class="container">
            <div class="row">
              <div class="col-sm-2 p-1"><button
                  class="btn btn-link btn-block text-left p-1" style="margin-right: 3px !important; padding-right: 0px; "
                  type="button"
                   ><i class="fas fa-wrench fa-1x mr-2"></i> <i class="fas fa-edit fa-1x"></i></button></div>
              <div class="col-sm-10">
                <button
                  class="btn btn-link btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  Collapsible Group Item #1
                </button>
              </div>
            </div>
          </div>
        </h2>
      </div>

      <div
        id="collapseOne"
        class="collapse show"
        aria-labelledby="headingOne"
        data-parent="#accordionExample"
      >
        <div class="card-body">
          Some placeholder content for the first accordion panel. This panel is
          shown by default, thanks to the <code>.show</code> class.
        </div>
      </div>
    </div>
  </div>
</div>
